<template>
	<div>
		<notifications />
		<section class="heading">
			<h1 class="title">Receipts</h1>
			<router-link to="receipts/create" class="btn btn-primary btn-lg">Add new Receipts</router-link>
		</section>
        <preloader v-if="isLoading"></preloader>
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr>
						<th>Payment No.</th>
						<th>Invoice No.</th>
						<th>Note</th>
						<th width="15%">Amount</th>
						<th>Payment Date</th>
						<th>Last Sent Email</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in receipts.data" :key="item.id">
						<td>
							<b><router-link :to="relativeUrl(`/receipts/${item.id}/view`)">{{ item.number }}</router-link></b> <br/>
						</td>
						<td><b><router-link :to="relativeUrl(`/invoices/${item.invoice_id}/view`)" target="_blank">{{ item.invoice.number }}</router-link></b> <br/></td>
						<td>{{ item.note }}</td>
						<td>{{ formatPrice(item.amount) }}</td>
						<td>{{ displayDate(item.date) }}</td>
						<td>
							<time-ago :datetime="`${item.last_sent_email_at}`" long v-if="isValidDate(item.last_sent_email_at)"></time-ago>
						</td> 
						<td>
							<action-button id="dropdownMenu1">
								<ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
									<li><router-link :to="relativeUrl(`/receipts/${item.id}/edit`)">Edit</router-link></li>
									<li><router-link :to="relativeUrl(`/receipts/create?duplicate_id=${item.id}`)">Duplicate</router-link></li>
									<li><router-link :to="relativeUrl(`/receipts/${item.id}/view`)">View</router-link></li>
									<li><a href="#" @click="remove(item.id)">Delete</a></li>
								</ul>
							</action-button>
						</td>
					</tr>
					<tr colspan="5" v-if="receipts.data.length <= 0">
						No data
					</tr>
				</tbody>
			</table>
		</div>
		<amy-pagination :pagination="receipts"></amy-pagination>
	</div>
</template>

<script>
import { getPage, relativeUrl, formatPrice, displayDate, isValidDate } from "../../helpers";
import AmyPagination from "../AmyPagination.vue";
import ActionButton from "../ActionButton.vue";
import TimeAgo from "vue2-timeago";
import Preloader from "../Preloader.vue";

export default {
	components: {
		AmyPagination, ActionButton, TimeAgo, Preloader
	},
	data() {
		return {
			receipts: {
				total: 0,
				per_page: 10,
				from: 1,
				to: 0,
				current_page: 1,
				data: [],
			},
			isLoading: false,
		}
	},
	beforeMount() {
		this.getInvoices();
	},
	beforeRouteUpdate(to, from, next) {
		this.getInvoices(to);
		next();
	},
	methods: {
		async remove(id) {
			this.isLoading = true;

			try {
				const response = await axios.delete(`/receipts/${id}`);
				this.getInvoices();
				this.$notify({
					type: 'success',
					title: 'Invoice Deleted!',
					text: 'You\'ve deleted the invoice!'
				})
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		async getInvoices(route = this.$route) {
			this.isLoading = true;

			try {
				const response = await axios.get(`/receipts?page=${getPage(route)}`);
				this.receipts = { ...response.data };
			} catch {
				this.$notify({
					type: 'error',
					title: 'Oops!',
					text: 'Sorry, an error occured!'
				})
			}

			this.isLoading = false;
		},
		relativeUrl, formatPrice, displayDate, isValidDate
	}
}
</script>
